import * as Yup from 'yup';

export const validate = Yup.object().shape({
    nombre: Yup.string().required('Campo Obligatorio'),
    template4: Yup.object().shape({
        titulo: Yup.string().required('Campo Obligatorio'),
        contenido: Yup.string().required('Campo Obligatorio'),
        fondo: Yup.object({}).required('Campo Obligatorio').nullable(),
    })
});
    